import { render } from "./ButtonLocation.vue?vue&type=template&id=d0673e0e&scoped=true"
import script from "./ButtonLocation.vue?vue&type=script&lang=js"
export * from "./ButtonLocation.vue?vue&type=script&lang=js"

import "./ButtonLocation.vue?vue&type=style&index=0&id=d0673e0e&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d0673e0e"]])

export default __exports__